<template>
  <div class="container">
    <div>
      <div class="card maadi-dark-card mb-2" v-if="searchParams !== null" v-on:keyup.enter="search">
        <div class="card-body">
          <div class="m-1 text-center" style="font-size: 1.4em; font-weight: 500">
            Activity Search
          </div>
          <div class="d-flex align-items-end">
            <b-form-group label="Subject Line Text" class="m-1 flex-fill">
              <b-form-input v-model="filter.subject"></b-form-input>
            </b-form-group>
            <b-form-group label="Note Text" class="m-1 flex-fill">
              <b-form-input v-model="filter.note"></b-form-input>
            </b-form-group>
            <b-form-group label="Activity Type" class="m-1">
              <b-form-select v-model="filter.type" :options="activityTypeMapping"></b-form-select>
            </b-form-group>
            <!-- <b-form-group label="Activity Subtype" class="m-1">
              <b-form-select v-model="filter.subtype" :options="activitySubTypeMapping"></b-form-select>
            </b-form-group> -->
            <b-form-group label="Initiative Type" class="m-1">
              <b-form-select v-model="filter.initiative_type" :options="searchParams.initiatives"></b-form-select>
            </b-form-group>
          </div>
          <div class="d-flex">
            <b-form-group label="Author" class="m-1">
              <b-form-select v-model="filter.author" :options="searchParams.authors"></b-form-select>
            </b-form-group>
            <b-form-group label="Created On or After Date" class="m-1 flex-fill">
              <b-form-datepicker v-model="filter.start_date"></b-form-datepicker>
            </b-form-group>
            <b-form-group label="Created On or Before Date" class="m-1 flex-fill">
              <b-form-datepicker v-model="filter.end_date"></b-form-datepicker>
            </b-form-group>
          </div>
          <div class="d-flex justify-content-center">
            <button class="btn maadi-button m-1" @click="search">Search</button>
          </div>
          <div class="d-flex flex-column m-2" v-if="activities !== null">
              <div>
                {{ total_results }} total results
              </div>
              <div v-if="this.activities.length !== 0">
                Page {{ filter.pageNumber+1 }} of {{ Math.ceil(total_results/20) }}
              </div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div v-if="activities !== null">
          <div class="card maadi-dark-card mb-2" >
            <div class="card-body d-flex">
              <div class="d-flex">
                <button class="btn maadi-button m-1" :disabled="this.filter.pageNumber === 0" @click="previousPage">Previous Page</button>
                <button class="btn maadi-button m-1" :disabled="this.activities.length === 0" @click="nextPage">Next Page</button>
              </div>
              <div class="d-flex m-1 ml-auto">
                <div v-if="!isLoadingExport && exportURL === null" class="btn maadi-button" @click="exportResults" style="cursor: pointer">Export</div>
                <a v-if="!isLoadingExport && exportURL !== null" class="btn maadi-button" :href="exportURL" style="cursor: pointer"><i class="fas fa-download"></i></a>
                <div v-if="isLoadingExport" class="spinner-grow text-light" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
            <div>
              <single-activity class="mb-2" v-bind:activity="activity" v-for="activity in activities" :key="activity.id"></single-activity>
            </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import activityAPI from '../../api/activity'
import SingleActivity from './SingleActivityInList'
import ActivityConstants from './ActivityConstants'

export default {
  name: '',
  components: {SingleActivity},
  computed: {
    activityTypeMapping () {
      let activityTypes = []
      ActivityConstants.activityMapping.forEach((x) => {
        activityTypes.push(x.type)
      })
      return activityTypes
    },
    // activitySubTypeMapping () {
    //   if (!('type' in this.filter) || this.filter.type === null) {
    //     return []
    //   }
    //   let activityTypeObject = ActivityConstants.activityMapping.filter((x) => x.type === this.filter.type)
    //   return activityTypeObject[0].subTypes
    // }
  },
  data: function () {
    return {
      filter: {
        pageNumber: 0
      },
      activities: null,
      searchParams: null,
      isLoadingExport: false,
      exportURL: null
    }
  },
  methods: {
    setActivities () {
      this.$store.commit('setIsLoading', true)
      this.activities = null
      activityAPI.getActivityIndex(this.filter).then(
        result => {
          this.activities = result.data.data.search_results
          this.searchParams = result.data.data.search_params
          this.total_results = result.data.data.total_results
          this.$store.commit('setIsLoading', false)
        }
      )
    },
    exportResults () {
      this.isLoadingExport = true
      activityAPI.getExportOfActivities(this.filter).then(
        response => {
          this.isLoadingExport = false
          if (response.result.success) {
            this.exportURL = response.result.message
          }
        }
      )
    },
    search () {
      this.filter.pageNumber = 0
      this.setActivities()
    },
    nextPage () {
      this.filter.pageNumber++
      this.setActivities()
    },
    previousPage () {
      this.filter.pageNumber--
      this.setActivities()
    }
  },
  mounted: function () {
    this.setActivities()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/activities/ActivitySearch.vue